import React from 'react';
import { Container, Box, NavButton } from './style';
import PropTypes from 'prop-types';

const Pagination = ({
  itemsCount = 0,
  pageSize,
  handlePageChange,
  currentPage,
  handlePreviousChange,
  onChangePageSize,
}) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(itemsCount / pageSize); i++) {
    pageNumbers.push(i);
  }

  return (
    <Container>
      <Box>
        <NavButton
          disabled={currentPage <= 1}
          onClick={handlePreviousChange}
          className={currentPage <= pageNumbers.length ? '' : 'active-text'}
        >
          <div className="btn"> {`<`} </div>
        </NavButton>
        <div className="page-list">
          {pageNumbers.map((page, index) => (
            <div key={index} className="page">
              <div
                className={page === currentPage ? 'active' : 'non-active'}
                onClick={() => onChangePageSize(page)}
              >
                {page}
              </div>
            </div>
          ))}
        </div>

        <NavButton
          onClick={handlePageChange}
          disabled={currentPage >= pageNumbers.length}
          className={currentPage >= pageNumbers.length ? '' : 'active-text'}
        >
          <div className="btn"> {`>`} </div>
        </NavButton>
      </Box>
    </Container>
  );
};

export default Pagination;

Pagination.propTypes = {
  itemsCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  handlePreviousChange: PropTypes.func.isRequired,
  onChangePageSize: PropTypes.func.isRequired,
};
